//console.log("home js...");

const toTimestamp = (strDate) => {
  const dt = Date.parse(strDate);
  return dt / 1000;
};

let ny_date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
// console.log("ny_date: " + ny_date);
// console.log("ny_date: " + toTimestamp(ny_date));
// console.log("test date:" + toTimestamp("5/11/2023, 3:29 PM"));

let test_date = $('.hp-module-a').data('test');
// console.log("test_date from attribute: " + toTimestamp(test_date));

$('.hp-module-a .block-container').each(function() {
	let expireString = $(this).data('expire');
	if (expireString) {
		// console.log("expireString: " + expireString);
		let expireDate = toTimestamp(expireString);
		let nowDateString = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
		let nowDate = toTimestamp(nowDateString);
		// console.log("nowDate: " + nowDate);
		// console.log("expireDate: " + expireDate);
		if (nowDate > expireDate) {
			// console.log("removing hp module block container");
			$(this).remove();
		} else {
			// console.log("don't remove yet");
		}
	}
});


/* Homepage Redesign Scripts */

function onHomeResize() {
	$('.grid-section.js-align').each(function() {
		let tallest = 0;
		$(this).find('.content .inner').each(function() {
			let height = $(this).height();
			if (height > tallest) tallest = height;
		});
		console.log("tallest: " + tallest);
		$(this).find('.content').css('height', Math.ceil(tallest)+'px');
	});
}

$(window).on('resize', function() {
	onHomeResize();
});



function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		infinite:false,
		slidesToShow:1.2,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

$(document).ready(function() {
	onHomeResize();
	mobileOnlySlider(".carousel.count-3,.carousel.count-2", false, false, 767);
	$('.collection-products').slick({
		mobileFirst: true,
		infinite:false,
		slidesToShow:2,
		arrows:true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow:4,
					arrows:true
				}
			},
			{
				breakpoint: 1025,
				settings: {
					slidesToShow:5,
					arrows:true
				}
			}
		]
	});
	
	$('.favorites-section.carousel').slick({
		mobileFirst: true,
		infinite:false,
		slidesToShow:1.2,
		arrows:false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow:3
				}
			}
		]
	});
	
	var promoBanner = $('#promo-banner');
	var isIndex = $('.template-index').length;
	if (promoBanner.length == 1 && isIndex == 1) {
		$('#promo-banner-shell').append(promoBanner);
		$('.body').addClass('promo-banner-active');
		// $('#promo-banner').addClass('active');
		$('#promo-banner').slick({
			slidesToShow:1,
			arrows:false,
			autoplay:true,
			autoplaySpeed: 4000
		});
	}
	
	// $(window).on('load', function() {
	// 	console.log("window load refresh products slider");
	// 	$('.collection-products').slick('refresh');
	// });
	
});
